module.exports = __webpack_public_path__ + "static/Youth-Groups-426da9c40fa7b3346e58e16c84787a03.jpg";